import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SharedModule } from "../../../ui-components/shared.module";
import { NgClass } from '@angular/common';

@Component({
    selector: 'vw-app-menu-central',
    imports: [
        SharedModule,
        NgClass
    ],
    templateUrl: './app-menu-central.component.html',
    styleUrl: './app-menu-central.component.scss'
})
export class AppMenuCentralComponent {
  @Input() isMenuOpen = false;
  @Output() openAIPopup = new EventEmitter<void>();

  isJumping = false;
  isPreparing = false;

  onContextMenu(event: MouseEvent) {
    event.preventDefault();
  }

  onAnimationEnd(event: AnimationEvent) {
    if (event.animationName.endsWith('carrotJump')) {
      setTimeout(() => {
        this.isJumping = false;
      }, 200);
    }
  }

  prepare() {
    if (!this.isJumping && !this.isMenuOpen) {
      this.isPreparing = true;
    }
  }

  jump() {
    if (!this.isJumping && this.isPreparing && !this.isMenuOpen) {
      this.isPreparing = false;
      this.isJumping = true;
      this.openAIPopup.emit();
    } else if (this.isMenuOpen && !this.isJumping && !this.isPreparing) {
      this.openAIPopup.emit();
    }
  }
}
